import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\GravePlot\ListGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/ListGravePlotController.php
* @route '/api/grave-plot'
*/
const ListGravePlotController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ListGravePlotController.url(options),
    method: 'get',
})

ListGravePlotController.definition = {
    methods: ["get","head"],
    url: '/api/grave-plot',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GravePlot\ListGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/ListGravePlotController.php
* @route '/api/grave-plot'
*/
ListGravePlotController.url = (options?: RouteQueryOptions) => {
    return ListGravePlotController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GravePlot\ListGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/ListGravePlotController.php
* @route '/api/grave-plot'
*/
ListGravePlotController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ListGravePlotController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\GravePlot\ListGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/ListGravePlotController.php
* @route '/api/grave-plot'
*/
ListGravePlotController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ListGravePlotController.url(options),
    method: 'head',
})

export default ListGravePlotController